import React from "react";

const Terms = () => {
    return (
        <div className="min-h-screen">
          
             <header className="bg-gradient-to-l from-blue-900 to-[#173363] py-16 text-center text-white">
                <h1 className="text-5xl font-bold">Terms of Use</h1>
                <p className="text-lg mt-2">Effective Date: January 09, 2025</p>
            </header>
            <main className="max-w-[140rem] mx-auto bg-gray-50 shadow-xl rounded-xl px-20 py-20 my-16">
            <section className="mb-10 mt-10">
                    {/* <h2 className="text-4xl font-bold text-gray-800 mb-4 text-center">Welcome to Our Privacy Policy</h2> */}
                    <p className="text-xl text-gray-600 leading-relaxed mt-10">
                    Welcome to SBAAA's website (the "Site"). These Terms of Use ("Terms") govern your use
                        of the Site, operated by SBAAA, LLC ("we," "us," or "our"). By accessing or using the
                        Site, you agree to be bound by these Terms. If you do not agree, please refrain from
                        using the Site.
                    </p>
                </section>

                <section className="mb-10">
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Acceptance of Terms</h2>
                    <p className="text-xl mb-3 text-gray-600"> By accessing and using this Site, you acknowledge that you have read, understood, and
                        agree to comply with these Terms, as well as our Privacy Policy. These Terms may be
                        updated periodically, and your continued use of the Site constitutes acceptance of any
                        changes.</p>
                
                </section>

                <section className="mb-10">
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Use of the Site</h2>
                    <p className="text-xl mb-3 text-gray-600">You agree to use the Site for lawful purposes only. You shall not:</p>
                    <ul className="list-disc list-inside text-xl text-gray-600 space-y-3">
                    <li>Use the Site in any way that violates applicable laws or regulations.</li>
                        <li>Attempt to gain unauthorized access to any portion of the Site, other accounts, or systems.</li>
                        <li>Transmit or upload viruses, malware, or any other harmful code.</li>
                        <li>Engage in any conduct that restricts or inhibits anyone else’s use of the Site.</li>
                    </ul>
                </section>

         
                
                <section>
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Contact Information</h2>
                    <p className="text-xl text-gray-600 leading-relaxed">
                        If you have any questions or concerns about this Privacy Policy, please contact us at:
                    </p>
                    <address className="mt-20 text-xl text-gray-700 font-medium not-italic">
                        SBAAA, LLC<br />
                        Attn: Legal Department <br />
                        2080 Fairport Nine Mile Point Rd.<br />
                        Dept. 74 <br />
                        Penfield, NY 14526-9998
                    </address>
                </section>

          
            </main>
        </div>
    );
};

export default Terms;
